import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: [],
    loading: false
  },
  getters: {
    details: state => state.details,
    agentDetails: state => state.agentDetails,
    loading: state => state.loading
  },
  actions: {
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/CustomerIndividualsQuery/" + id)
          .then(r => {
            commit("setDetails", r.data);
            commit("setLoading", false);

            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/CustomerIndividuals", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    createAgent({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/AgentIndividuals", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    createAgentFromCustomer({ commit, dispatch }, model) {
      debugger;
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/AgentIndividuals/create-individual-agent-from-individual-party", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    createSupplierFromParty({ commit, dispatch }, model) {
      debugger;

      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/SupplierIndividuals/create-individual-supplier-from-individual-party", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    confirmIndividualAgent({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("BusinessParties/api/AgentIndividuals/confirm-status", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    rejectIndividualAgent({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("BusinessParties/api/AgentIndividuals/reject-status", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createSupplier({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/SupplierIndividuals", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    createPromoter({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/PromotersIndividuals", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    update({ commit, dispatch }, model) {
      return ajax
        .put("BusinessParties/api/CustomerIndividuals", model)
        .then(() => {
          //dispatch('fetch')
        });
    },
    updateAgent({ commit, dispatch }, model) {
      return ajax
        .put("BusinessParties/api/AgentIndividuals", model)
        .then(() => {
          //dispatch('fetch')
        });
    },
    updateSupplier({ commit, dispatch }, model) {
      return ajax
        .put("BusinessParties/api/SupplierIndividuals", model)
        .then(() => {
          //dispatch('fetch')
        });
    }
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    }
  }
};
